import hamburger from "./components/hamburger";
import packery from "./components/packery";
import attractions from "./components/attractions";
import map from "./components/map";
import heroVideo from "./components/hero-video";
import header from "./components/header";
import scroll from "./components/scroll";
import images from "./components/images";
import infinitescroll from "./components/infinitescroll";
import slickjs from "./components/slick";

document.addEventListener("DOMContentLoaded", () => {

    hamburger();
    packery();
    attractions();
    map();
    header();
    scroll();
    images();
    infinitescroll();
    heroVideo();
    slickjs();
});
